import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router";

import { AppContext } from '../../context.js';

function Partner() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  let { id } = useParams();

  const [loading, setLoading] = useState(false);


  if (loading) {
    return (
      <></>
    );
  } 

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8 col-lg-offset-2">

          <div style={{paddingTop: "20px"}} />

          <div className="card">
            <div className="card-header text-center">
              <div className="typo-strong-200">Signature Pad Example</div>

            

              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partner;
